import { sceneBuilder } from '@studio/program';
import { attachAudioPresenterSources } from 'utils/broadcastSourceHelper';

/**
 *  What does this function do?
 * This util funciton uses the sceneBuilder to return a scene object
 * param {Object} broadcast - the broadcast object
 * param {Object} broadcastSources - the broadcast sources object
 * param {Object} attendeeMuteStatus - the attendee mute status object
 * param {Object} sceneLayers - the sceneLayers object
 * param {Object} sceneLayouts - the scene Layouts object
 * param {Object} fonts - fonts object
 */
export const buildNewScene = ({
  sceneLayers,
  banners,
  broadcast,
  broadcastSources,
  sceneLayouts,
  attendeeMuteStatus,
  fonts = {}
}) => {
  const {
    program: {
      _id: programId,
      layers: programLayers,
      layout: programLayout
    } = {}
  } = broadcast;

  const combinedLayers = [...sceneLayers, ...banners];

  // current sources on the scene
  const currentSources = programLayers
    .map(ls => broadcastSources.find(s => s._id === ls.source._id))
    .filter(s => s);

  // update layout
  const sceneLayout = sceneLayouts[programId] || sceneLayouts[programLayout];

  const withAudioPresenterSources = attachAudioPresenterSources(
    currentSources,
    attendeeMuteStatus
  );

  return sceneBuilder(
    sceneLayout,
    withAudioPresenterSources,
    combinedLayers,
    {},
    {},
    fonts
  );
};
